import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function HospitalIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M11 9H9V7H11V5H13V7H15V9H13V11H11V9ZM22 3H21V23H3V3H2V1H22V3ZM13 21V16H11V21H13ZM19 3H5V21H9V16H7.46436V14H16.5357V16H15V21H19V3H19Z",
    fill: "currentColor"
  }));
}